export const getCustomerSuccess = (customers) => ({
    type: 'CUSTOMERS_RECEIVED',
    payload: {
        customers
    }
});